const index = () => import('./views/index')
export default [
  {
    path: '',
    name: 'mobileAppLandingPage',
    component: index,
    meta: { auth: false, userType: 'both' }
  }
]
